"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Settings = require("./Settings");
Object.keys(_Settings).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Settings[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Settings[key];
    }
  });
});
var _SystemCheck = require("./SystemCheck");
Object.keys(_SystemCheck).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SystemCheck[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SystemCheck[key];
    }
  });
});
var _JoinComponent = require("./JoinComponent");
Object.keys(_JoinComponent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _JoinComponent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _JoinComponent[key];
    }
  });
});
var _JoinPage = require("./Page/JoinPage");
Object.keys(_JoinPage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _JoinPage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _JoinPage[key];
    }
  });
});
var _AgoraCameraPreview = require("./AgoraCameraPreview/AgoraCameraPreview");
Object.keys(_AgoraCameraPreview).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AgoraCameraPreview[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AgoraCameraPreview[key];
    }
  });
});